export * from './frequency-table'
